(function ($) {
    $('.switch-view-list').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('view-active');
        $('.switch-view-grid').removeClass('view-active');
		$('.releases-items').removeClass('releases-grid').addClass('releases-list');

		// set aria attribute
		$('.switch-view-grid').attr('aria-pressed', 'false');
		$(this).attr('aria-pressed', 'true');
		

        CP.NEWS.initGridState();
    });
	$('.switch-view-grid').on('click', function (e) {
        e.preventDefault();
        $(this).addClass('view-active');
        $('.switch-view-list').removeClass('view-active');
		$('.releases-items').removeClass('releases-list').addClass('releases-grid');

		// set aria attribute
		$('.switch-view-list').attr('aria-pressed', 'false');
		$(this).attr('aria-pressed', 'true');
		

        CP.NEWS.initGridState();
    });
})(jQuery);